import { Component } from '@angular/core';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.scss']
})
export class NavbarComponent {

  constructor() { }

  scrollToElement($element): void {
    console.log($element);
    var elemento = document.getElementById($element);
    elemento.scrollIntoView({behavior: "smooth", block: "start", inline: "nearest"});
  }

}
